/**
 * @file useNotesBasePath.ts
 * @brief Which shell a Notes surface is rendered in — `/app`, `/company`, or none.
 *
 * @details
 * Notes are mounted in all three shells, so every link has to be built from
 * the one the reader is actually in.
 *
 * The super-admin shell was left out at first, on the reasoning that a super
 * admin browses other people's meetings and is never their owner. True about
 * MEETINGS, and irrelevant to notes: a super admin is a user like any other and
 * has their own. Leaving `/admin` out simply locked them out of their own
 * library, since `RequireEmployeeApp` redirects them away from `/app` and
 * `/company` is for company admins. (23-08-2026)
 *
 * What the admin shell does NOT get is the meeting-side attach control — see
 * `MeetingDetailView`, which gates that on scope rather than on this.
 *
 * @references
 * - features/employee-boardroom/useBoardroomBasePath.ts (the same idea for capture)
 *
 * @author DES
 * @date 21-08-2026
 */

import { useLocation } from "react-router-dom";

export function useNotesBasePath(): "/admin" | "/app" | "/company" {
  const { pathname } = useLocation();
  if (pathname.startsWith("/company")) return "/company";
  if (pathname.startsWith("/admin")) return "/admin";
  return "/app";
}
